<template>
  <div>
    <span v-if="!value">
      <div>
        <div class="block pr-4 pb-4 w-1/2">
          <p
            class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
          >
            School name
          </p>
        </div>
        <div class="block pb-4 w-1/2">
          <p
            class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
          >
            Not provided
          </p>
        </div>
      </div>
      <div>
        <div class="block pr-4 pb-4 w-1/2">
          <p
            class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
          >
            School email
          </p>
        </div>
        <div class="block pb-4 w-1/2">
          <p
            class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
          >
            Not provided
          </p>
        </div>
      </div>
    </span>
    <span v-else v-for="(school, index) in value" :key="index">
      <div
        :class="{
          'border-t border-gray-500 pt-4': hasTopBorder(index)
        }"
      >
        <div class="block pr-4 pb-4 w-1/2">
          <p
            class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
          >
            School name
          </p>
        </div>
        <div class="block pb-4 w-1/2">
          <p
            class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black"
          >
            {{ school.School_name }}
          </p>
        </div>
        <div class="block pr-4 pb-4 w-1/2">
          <p
            class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
          >
            School email
          </p>
        </div>
        <div class="block pb-4 w-1/2">
          <p
            class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black overflow-hidden"
          >
            {{ school.School_Email }}
          </p>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "DoeCellSchool",
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Array
    }
  },
  methods: {
    hasTopBorder(index) {
      return index !== 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
